import * as React from 'react';

import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-black selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-full border bg-transparent px-3 py-1 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 xl:text-lg text-sm ',
        '',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border border-[#cdc4c1]',
        // `outline-none` above left keyboard users with no focus indicator at
        // all (WCAG 2.4.7). An outline rather than a ring so nothing reflows.
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#231f20]',
        className
      )}
      {...props}
    />
  );
}

export { Input };
